
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { PaymentRequestModel } from '@/models/payment-request';
import ListPaymentRequest from './components/ListPaymentRequest.vue';
import paymentRequestServices from '@/services/payment-request-services';
import commonService from '@/services/common-services';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
@Component({
    components: {
        ListPaymentRequest,
        Loading,
        Paging,
        ConfirmModal
    }
})
export default class MainPaymentRequest extends Vue {
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listPaymentRequest: PaymentRequestModel[] = [];
    private isLoading = false;
    private chinaAddress = null;
    private showNextConfirm = true;
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn hủy yêu cầu này không?';

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listPaymentRequest.filter(x => x.isChecked === true).length;
    }

    private async created() {
        this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        const result = await paymentRequestServices.getPaymentRequest(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListPaymentRequest: PaymentRequestModel[] = [];
            this.pageSettings.total = result.data.total;

            for (const item of result.data.data) {
                const paymentRequest = new PaymentRequestModel();
                paymentRequest.id = item.ID;
                paymentRequest.uId = item.UID;
                paymentRequest.userName = item.Username;
                paymentRequest.status = item.Status;
                paymentRequest.statusDetail = DATA.requestPaymentStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                paymentRequest.createdDate = item.CreatedDate;
                paymentRequest.createdBy = item.CreatedBy;
                paymentRequest.note = item.Note;
                paymentRequest.numberOfPack = item.NumberOfPack;

                tmpListPaymentRequest.push(paymentRequest);
            }
            this.listPaymentRequest = tmpListPaymentRequest;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        return paramsFilter;
    }

    private createNewPaymentRequest() {
        const routeData = this.$router.resolve({ name: 'payment-request-new' });
        window.open(routeData.href, '_blank');
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listPaymentRequest = this.listPaymentRequest.map(x => {
            return {
                ...x,
                isChecked: x.status === 1 ? isCheckAll : x.isChecked
            }
        });
    }

    private onCancelRequest() {
        if(this.totalChoose > 0) {
            this.isConfirm = true;
        }
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.submitCancelOrder();
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private async submitCancelOrder() {
        this.isLoading = true;
        const ids = this.listPaymentRequest
                    .filter(x => x.status === 1 && x.isChecked === true)
                    .map(x => x.id);
        let result: any = null;
        for (const id of ids) {
            result = await paymentRequestServices.removePaymentRequest(id);
        }
        

        if (result && result.status === 200 && result.data.data.status === true) {
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Hủy yêu cầu thành công!'});
            this.loadData();
        } else {
            this.isLoading = false;
        }
    }
}
